(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-contador"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('merlanis-barra-contador')) return;

    const FIN_DEL_DIA = 23 * 3600 + 59 * 60 + 59;
    const formateadores = new Map();

    const obtenerFormateador = (zona) => {
      if (!zona) return null;
      if (formateadores.has(zona)) return formateadores.get(zona);
      let formateador = null;
      try {
        formateador = new Intl.DateTimeFormat('en-GB', {
          timeZone: zona,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
      } catch (error) {
        formateador = null;
      }
      formateadores.set(zona, formateador);
      return formateador;
    };

    const segundosDelDia = (zona) => {
      const formateador = obtenerFormateador(zona);
      if (formateador) {
        const partes = {};
        formateador.formatToParts(new Date()).forEach((parte) => {
          partes[parte.type] = parte.value;
        });
        const horas = Number(partes.hour) % 24;
        return horas * 3600 + Number(partes.minute) * 60 + Number(partes.second);
      }
      const ahora = new Date();
      return ahora.getHours() * 3600 + ahora.getMinutes() * 60 + ahora.getSeconds();
    };

    class MerlanisBarraContador extends HTMLElement {
      connectedCallback() {
        if (this.inicioPendiente || this.intervalo) return;
        this.inicioPendiente = requestAnimationFrame(() => {
          this.inicioPendiente = null;
          if (!this.isConnected) return;
          this.iniciar();
        });
      }

      iniciar() {
        this.campos = ['horas', 'minutos', 'segundos'].map((unidad) =>
          this.querySelector(`[data-unidad="${unidad}"]`)
        );
        if (this.campos.some((campo) => !campo)) return;
        this.reloj = this.querySelector('[role="timer"]');
        this.mensajeFinal = this.querySelector('.merlanis-contador-finalizado');
        this.zona = this.dataset.zona || '';
        this.reanudar = () => this.actualizar();
        window.addEventListener('pageshow', this.reanudar);
        document.addEventListener('visibilitychange', this.reanudar);
        this.actualizar();
        this.intervalo = setInterval(() => this.actualizar(), 1000);
      }

      actualizar() {
        const restante = Math.max(0, FIN_DEL_DIA - segundosDelDia(this.zona));
        const valores = [Math.floor(restante / 3600), Math.floor(restante / 60) % 60, restante % 60];
        valores.forEach((valor, indice) => {
          const texto = String(valor).padStart(2, '0');
          if (this.campos[indice].textContent !== texto) this.campos[indice].textContent = texto;
        });
        this.reloj.setAttribute('aria-label', `Tiempo restante: ${valores[0]} horas, ${valores[1]} minutos y ${valores[2]} segundos`);
        const finalizado = restante === 0;
        this.dataset.finalizado = String(finalizado);
        if (this.mensajeFinal) this.mensajeFinal.hidden = !finalizado;
        this.hidden = false;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.inicioPendiente);
        this.inicioPendiente = null;
        clearInterval(this.intervalo);
        this.intervalo = null;
        window.removeEventListener('pageshow', this.reanudar);
        document.removeEventListener('visibilitychange', this.reanudar);
      }
    }

    customElements.define('merlanis-barra-contador', MerlanisBarraContador);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-promociones"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('barra-promociones')) return;

    class BarraPromociones extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        this.mensajes = Array.from(this.querySelectorAll('[data-bp-mensaje]'));
        this.actual = 0;
        this.pausado = false;
        this.sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.control = new AbortController();
        const opciones = { signal: this.control.signal };

        if (this.dataset.pausar === 'true') {
          this.addEventListener('mouseenter', () => { this.pausado = true; }, opciones);
          this.addEventListener('mouseleave', () => { this.pausado = false; }, opciones);
          this.addEventListener('focusin', () => { this.pausado = true; }, opciones);
          this.addEventListener('focusout', () => { this.pausado = false; }, opciones);
        }

        document.addEventListener('shopify:block:select', (evento) => {
          const indice = this.mensajes.findIndex((mensaje) => mensaje === evento.target);
          if (indice === -1) return;
          this.detenido = true;
          this.mostrar(indice);
        }, opciones);

        document.addEventListener('shopify:block:deselect', (evento) => {
          if (this.mensajes.includes(evento.target)) this.detenido = false;
        }, opciones);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.detener();
          } else {
            this.iniciar();
          }
        }, opciones);

        this.iniciar();
      }

      disconnectedCallback() {
        this.iniciado = false;
        this.detener();
        if (this.control) this.control.abort();
      }

      iniciar() {
        this.detener();
        if (this.mensajes.length < 2) return;
        const segundos = Math.max(1, Number(this.dataset.intervalo) || 2);
        this.intervalo = setInterval(() => {
          if (this.pausado || this.detenido) return;
          this.mostrar((this.actual + 1) % this.mensajes.length);
        }, segundos * 1000);
      }

      detener() {
        clearInterval(this.intervalo);
        this.intervalo = null;
      }

      mostrar(indice) {
        if (indice === this.actual && this.mensajes[indice].classList.contains('barra-promociones__mensaje--activo')) return;

        this.mensajes.forEach((mensaje, i) => {
          const activo = i === indice;
          mensaje.classList.toggle('barra-promociones__mensaje--activo', activo);
          mensaje.classList.remove('barra-promociones__mensaje--sacudida');
          if (activo) {
            mensaje.removeAttribute('aria-hidden');
          } else {
            mensaje.setAttribute('aria-hidden', 'true');
          }
          const enlace = mensaje.querySelector('a');
          if (enlace) {
            if (activo) {
              enlace.removeAttribute('tabindex');
            } else {
              enlace.setAttribute('tabindex', '-1');
            }
          }
        });

        const nuevo = this.mensajes[indice];
        if (this.dataset.animacion === 'sacudida' && !this.sinMovimiento) {
          void nuevo.offsetWidth;
          nuevo.classList.add('barra-promociones__mensaje--sacudida');
        }

        this.actual = indice;
      }
    }

    customElements.define('barra-promociones', BarraPromociones);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beneficios-inicio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('merlanis-beneficios')) return;
    customElements.define('merlanis-beneficios', class extends HTMLElement {
      connectedCallback() {
        this.control = new AbortController();
        const options = { signal: this.control.signal };
        this.slides = Array.from(this.querySelectorAll('.merlanis-beneficios-contenido'));
        this.dots = Array.from(this.querySelectorAll('.merlanis-beneficios-punto'));
        this.index = 0;
        this.busy = false;
        this.animations = [];
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
        this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.start()), options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.addEventListener('touchstart', event => { this.touchX = event.touches[0].clientX; this.touchY = event.touches[0].clientY; this.stop(); }, { ...options, passive: true });
        this.addEventListener('touchend', event => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1));
          else this.start();
        }, options);
        this.addEventListener('touchcancel', () => this.start(), options);
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.reduced.addEventListener('change', () => this.start(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.bloque === event.detail.blockId);
          if (index < 0) return;
          this.editing = true;
          this.show(index, true);
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editing = false; this.start(); }, options);
        this.start();
      }
      stop() { clearTimeout(this.timer); }
      start() {
        this.stop();
        if (this.slides.length < 2 || this.dataset.automatico !== 'true' || this.reduced.matches || document.hidden || this.hovered || this.editing || this.matches(':focus-within') || this.busy) return;
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.intervalo) || 2500);
      }
      async show(target, instant = false) {
        this.stop();
        if (!this.slides.length) return;
        if (this.busy && !instant) return;
        const next = (target + this.slides.length) % this.slides.length;
        if (instant) {
          this.animations.forEach(animation => animation.cancel());
          this.slides.forEach((slide, i) => {
            slide.classList.toggle('merlanis-beneficios-contenido--activo', i === next);
            slide.setAttribute('aria-hidden', String(i !== next));
            slide.inert = i !== next;
          });
          this.index = next;
          this.busy = false;
        } else if (next !== this.index) {
          this.busy = true;
          const previous = this.slides[this.index];
          const current = this.slides[next];
          const direction = target < this.index ? -1 : 1;
          previous.inert = true;
          previous.setAttribute('aria-hidden', 'true');
          current.classList.add('merlanis-beneficios-contenido--activo');
          current.inert = false;
          current.setAttribute('aria-hidden', 'false');
          this.index = next;
          this.updateDots();
          if (!this.reduced.matches) {
            this.animations = [
              previous.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-direction * 100}%)` }], { duration: 450, easing: 'ease-in-out' }),
              current.animate([{ transform: `translateX(${direction * 100}%)` }, { transform: 'translateX(0)' }], { duration: 450, easing: 'ease-in-out' })
            ];
            try { await Promise.all(this.animations.map(animation => animation.finished)); } catch { return; }
          }
          previous.classList.remove('merlanis-beneficios-contenido--activo');
          this.busy = false;
        }
        this.updateDots();
        this.start();
      }
      updateDots() { this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index))); }
      disconnectedCallback() {
        this.stop();
        this.control.abort();
        this.animations.forEach(animation => animation.cancel());
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-lateral"]) return;
  try {
    
  (() => {
    if (customElements.get('carrito-lateral')) return;

    const obtenerRaiz = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    class CarritoLateral extends HTMLElement {
      connectedCallback() {
        if (this.iniciado) return;
        this.iniciado = true;

        this.idSeccion = this.dataset.seccion;
        this.alEnviar = this.alEnviar.bind(this);
        this.alClicDocumento = this.alClicDocumento.bind(this);
        this.alTeclado = this.alTeclado.bind(this);
        this.alSeleccionarSeccion = this.alSeleccionarSeccion.bind(this);
        this.alDeseleccionarSeccion = this.alDeseleccionarSeccion.bind(this);

        document.addEventListener('submit', this.alEnviar, true);
        document.addEventListener('click', this.alClicDocumento, true);
        document.addEventListener('keydown', this.alTeclado);
        document.addEventListener('shopify:section:select', this.alSeleccionarSeccion);
        document.addEventListener('shopify:section:deselect', this.alDeseleccionarSeccion);

        this.addEventListener('click', (evento) => this.alClicInterno(evento));
        this.addEventListener('change', (evento) => this.alCambiar(evento));

        this.iniciarTemporizador();
      }

      disconnectedCallback() {
        this.iniciado = false;
        document.removeEventListener('submit', this.alEnviar, true);
        document.removeEventListener('click', this.alClicDocumento, true);
        document.removeEventListener('keydown', this.alTeclado);
        document.removeEventListener('shopify:section:select', this.alSeleccionarSeccion);
        document.removeEventListener('shopify:section:deselect', this.alDeseleccionarSeccion);
        clearInterval(this.intervalo);
        document.documentElement.classList.remove('carrito-lateral-bloqueado');
      }

      get panel() {
        return this.querySelector('[data-cl-panel]');
      }

      abrir() {
        if (this.classList.contains('carrito-lateral--abierto')) return;
        this.focoPrevio = document.activeElement;
        this.classList.add('carrito-lateral--abierto');
        document.documentElement.classList.add('carrito-lateral-bloqueado');
        const panel = this.panel;
        if (panel) panel.focus({ preventScroll: true });
      }

      cerrar() {
        this.classList.remove('carrito-lateral--abierto');
        document.documentElement.classList.remove('carrito-lateral-bloqueado');
        if (this.focoPrevio && typeof this.focoPrevio.focus === 'function') {
          this.focoPrevio.focus({ preventScroll: true });
        }
      }

      alTeclado(evento) {
        if (evento.key === 'Escape' && this.classList.contains('carrito-lateral--abierto')) this.cerrar();
      }

      alSeleccionarSeccion(evento) {
        if (evento.detail && evento.detail.sectionId === this.idSeccion) this.abrir();
      }

      alDeseleccionarSeccion(evento) {
        if (evento.detail && evento.detail.sectionId === this.idSeccion) this.cerrar();
      }

      alClicDocumento(evento) {
        if (this.contains(evento.target)) return;
        const enlace = evento.target.closest('#cart-icon-bubble, a[href]');
        if (!enlace) return;
        const esBurbuja = enlace.id === 'cart-icon-bubble';
        const destino = enlace.getAttribute('href') || '';
        const urlCarrito = this.dataset.urlCarrito || '/cart';
        if (!esBurbuja && destino !== urlCarrito && destino !== urlCarrito + '/') return;
        evento.preventDefault();
        evento.stopPropagation();
        this.abrir();
      }

      alClicInterno(evento) {
        if (evento.target.closest('[data-cl-cerrar]')) {
          this.cerrar();
          return;
        }
        const boton = evento.target.closest('[data-cl-cambiar]');
        if (boton) {
          this.cambiarCantidad(Number(boton.dataset.linea), Math.max(0, Number(boton.dataset.cantidad)));
        }
      }

      alCambiar(evento) {
        const campo = evento.target.closest('[data-cl-cantidad-campo]');
        if (!campo) return;
        const cantidad = Math.max(0, parseInt(campo.value, 10) || 0);
        this.cambiarCantidad(Number(campo.dataset.linea), cantidad);
      }

      alEnviar(evento) {
        const formulario = evento.target;
        if (!(formulario instanceof HTMLFormElement)) return;
        const accion = formulario.getAttribute('action') || '';
        if (accion.indexOf('/cart/add') === -1) return;
        evento.preventDefault();
        evento.stopPropagation();
        this.agregar(formulario, evento.submitter);
      }

      seccionesARenderizar() {
        const secciones = [this.idSeccion];
        if (document.getElementById('cart-icon-bubble')) secciones.push('cart-icon-bubble');
        return secciones;
      }

      marcarBoton(boton, cargando) {
        if (!boton) return;
        const icono = boton.querySelector('.loading__spinner');
        if (cargando) {
          boton.setAttribute('aria-disabled', 'true');
          boton.classList.add('loading');
          if (icono) icono.classList.remove('hidden');
        } else {
          boton.removeAttribute('aria-disabled');
          boton.classList.remove('loading');
          if (icono) icono.classList.add('hidden');
        }
      }

      async agregar(formulario, boton) {
        if (boton && boton.getAttribute('aria-disabled') === 'true') return;
        this.marcarBoton(boton, true);

        const datos = new FormData(formulario);
        datos.append('sections', this.seccionesARenderizar().join(','));
        datos.append('sections_url', window.location.pathname);

        try {
          const respuesta = await fetch(obtenerRaiz() + 'cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: datos
          });
          const json = await respuesta.json();

          if (!respuesta.ok || json.status) {
            await this.recargar();
            this.mostrarError(json.description || json.message || 'No se pudo añadir el producto.');
            this.abrir();
            return;
          }

          this.renderizar(json.sections, json);
          const modal = formulario.closest('quick-add-modal');
          if (modal && typeof modal.hide === 'function') modal.hide(true);
          if (this.dataset.abrirAlAgregar === 'true') this.abrir();
        } catch (error) {
          this.mostrarError('No se pudo añadir el producto. Inténtalo de nuevo.');
          this.abrir();
        } finally {
          this.marcarBoton(boton, false);
        }
      }

      async cambiarCantidad(linea, cantidad) {
        if (!linea) return;
        this.classList.add('carrito-lateral--cargando');

        try {
          const respuesta = await fetch(obtenerRaiz() + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              line: linea,
              quantity: cantidad,
              sections: this.seccionesARenderizar(),
              sections_url: window.location.pathname
            })
          });
          const json = await respuesta.json();

          if (!respuesta.ok || json.status) {
            await this.recargar();
            this.mostrarError(json.description || json.message || 'No se pudo actualizar la cantidad.');
            return;
          }

          this.renderizar(json.sections, json);
        } catch (error) {
          this.mostrarError('No se pudo actualizar el carrito. Inténtalo de nuevo.');
        } finally {
          this.classList.remove('carrito-lateral--cargando');
        }
      }

      async recargar() {
        try {
          const url = window.location.pathname + '?sections=' + this.seccionesARenderizar().join(',');
          const respuesta = await fetch(url);
          const secciones = await respuesta.json();
          this.renderizar(secciones);
        } catch (error) {
          return;
        }
      }

      renderizar(secciones, datosCarrito) {
        if (!secciones) return;
        const lector = new DOMParser();

        const htmlCarrito = secciones[this.idSeccion];
        if (htmlCarrito) {
          const documento = lector.parseFromString(htmlCarrito, 'text/html');
          const nuevoPanel = documento.querySelector('[data-cl-panel]');
          const panel = this.panel;
          if (nuevoPanel && panel) panel.innerHTML = nuevoPanel.innerHTML;
        }

        const htmlBurbuja = secciones['cart-icon-bubble'];
        const burbuja = document.getElementById('cart-icon-bubble');
        if (htmlBurbuja && burbuja) {
          const documento = lector.parseFromString(htmlBurbuja, 'text/html');
          const contenido = documento.querySelector('.shopify-section');
          if (contenido) burbuja.innerHTML = contenido.innerHTML;
        }

        this.iniciarTemporizador();

        if (datosCarrito && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carrito-lateral', cartData: datosCarrito });
        }
      }

      mostrarError(mensaje) {
        const caja = this.querySelector('[data-cl-error]');
        if (!caja) return;
        caja.textContent = mensaje;
        caja.hidden = false;
      }

      iniciarTemporizador() {
        clearInterval(this.intervalo);
        const destinos = this.querySelectorAll('[data-cl-tiempo]');
        if (!destinos.length) return;

        const minutos = Number(this.dataset.minutos) || 10;
        const clave = 'carrito-lateral-fin';
        let fin = 0;

        try {
          fin = Number(sessionStorage.getItem(clave)) || 0;
        } catch (error) {
          fin = 0;
        }

        const reiniciar = () => {
          fin = Date.now() + minutos * 60000;
          try {
            sessionStorage.setItem(clave, String(fin));
          } catch (error) {
            return;
          }
        };

        if (!fin || fin <= Date.now()) reiniciar();

        const pintar = () => {
          let restante = fin - Date.now();
          if (restante <= 0) {
            reiniciar();
            restante = fin - Date.now();
          }
          const total = Math.ceil(restante / 1000);
          const texto = String(Math.floor(total / 60)).padStart(2, '0') + ':' + String(total % 60).padStart(2, '0');
          destinos.forEach((destino) => {
            destino.textContent = texto;
          });
        };

        pintar();
        this.intervalo = setInterval(pintar, 1000);
      }
    }

    customElements.define('carrito-lateral', CarritoLateral);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["despedida-merla"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('merlanis-despedida-pulsante')) return;

    customElements.define('merlanis-despedida-pulsante', class extends HTMLElement {
      connectedCallback() {
        this.preferencia = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.actualizar = () => {
          if (this.animacion) this.animacion.cancel();
          if (this.preferencia.matches) return;
          this.animacion = this.animate(
            [
              { transform: 'scale(1)', opacity: 1 },
              { transform: 'scale(1.35)', opacity: 0.55 },
              { transform: 'scale(1)', opacity: 1 }
            ],
            { duration: 1500, iterations: Infinity, easing: 'ease-in-out' }
          );
        };
        this.preferencia.addEventListener('change', this.actualizar);
        this.actualizar();
      }

      disconnectedCallback() {
        if (this.animacion) this.animacion.cancel();
        if (this.preferencia) this.preferencia.removeEventListener('change', this.actualizar);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('resenas-clientes')) return;

    class ResenasClientes extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('[data-rc-pista]');
        if (!this.pista) return;
        this.control = new AbortController();
        const opciones = { signal: this.control.signal };
        this.anterior = this.querySelector('[data-rc-flecha="-1"]');
        this.siguiente = this.querySelector('[data-rc-flecha="1"]');

        this.querySelectorAll('[data-rc-flecha]').forEach((flecha) => {
          flecha.addEventListener('click', () => this.mover(Number(flecha.dataset.rcFlecha)), opciones);
        });

        this.pista.addEventListener('scroll', () => this.actualizar(), { passive: true, signal: this.control.signal });
        window.addEventListener('resize', () => this.actualizar(), opciones);

        document.addEventListener('shopify:block:select', (evento) => {
          if (!this.pista.contains(evento.target)) return;
          this.pista.scrollTo({ left: evento.target.offsetLeft - this.pista.offsetLeft, behavior: 'smooth' });
        }, opciones);

        this.actualizar();
      }

      disconnectedCallback() {
        this.control?.abort();
      }

      mover(direccion) {
        const tarjeta = this.pista.querySelector('.resenas-clientes__resena');
        if (!tarjeta) return;
        const espacio = parseFloat(getComputedStyle(this.pista).columnGap) || 0;
        this.pista.scrollBy({ left: direccion * (tarjeta.offsetWidth + espacio), behavior: 'smooth' });
      }

      actualizar() {
        const maximo = this.pista.scrollWidth - this.pista.clientWidth;
        if (this.anterior) this.anterior.disabled = this.pista.scrollLeft <= 2;
        if (this.siguiente) this.siguiente.disabled = this.pista.scrollLeft >= maximo - 2;
      }
    }

    customElements.define('resenas-clientes', ResenasClientes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-loop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('merlanis-resenas-infinito')) return;

    customElements.define('merlanis-resenas-infinito', class extends HTMLElement {
      connectedCallback() {
        this.marco = requestAnimationFrame(() => this.iniciar());
      }

      iniciar() {
        this.ventana = this.querySelector('.merlanis-resenas-ventana');
        this.pista = this.querySelector('.merlanis-resenas-pista');
        this.grupo = this.querySelector('[data-original]');
        if (!this.grupo || !this.grupo.children.length || !this.isConnected) return;
        this.control = new AbortController();
        const opciones = { signal: this.control.signal };
        this.reducido = matchMedia('(prefers-reduced-motion: reduce)');
        this.encima = false;
        this.enfocado = false;
        this.presionado = false;
        this.seleccionado = false;
        this.ventana.addEventListener('pointerenter', (evento) => {
          if (evento.pointerType !== 'mouse') return;
          this.encima = this.dataset.pausaHover === 'true';
          this.estado();
        }, opciones);
        this.ventana.addEventListener('pointerleave', (evento) => {
          if (evento.pointerType === 'mouse') this.encima = false;
          this.presionado = false;
          this.estado();
        }, opciones);
        this.ventana.addEventListener('pointerdown', (evento) => {
          if (evento.pointerType === 'mouse') return;
          this.presionado = true;
          this.estado();
        }, opciones);
        const soltar = () => {
          if (!this.presionado) return;
          this.presionado = false;
          this.estado();
        };
        this.ventana.addEventListener('pointerup', soltar, opciones);
        this.ventana.addEventListener('pointercancel', soltar, opciones);
        document.addEventListener('pointerup', soltar, opciones);
        document.addEventListener('touchend', soltar, opciones);
        document.addEventListener('touchcancel', soltar, opciones);
        this.ventana.addEventListener('focusin', () => {
          this.enfocado = this.ventana.matches(':focus-visible');
          this.estado();
        }, opciones);
        this.ventana.addEventListener('focusout', () => {
          this.enfocado = false;
          this.estado();
        }, opciones);
        document.addEventListener('visibilitychange', () => this.estado(), opciones);
        this.reducido.addEventListener('change', () => this.construir(), opciones);
        this.addEventListener('shopify:block:select', () => {
          this.seleccionado = true;
          this.construir();
        }, opciones);
        this.addEventListener('shopify:block:deselect', () => {
          this.seleccionado = false;
          this.construir();
        }, opciones);
        this.observador = new ResizeObserver(() => {
          const ancho = this.ventana.clientWidth;
          const tarjeta = this.grupo.firstElementChild.getBoundingClientRect().width;
          const medida = `${ancho}:${tarjeta}`;
          if (medida === this.medida) return;
          this.medida = medida;
          this.construir();
        });
        this.observador.observe(this.ventana);
        this.observador.observe(this.grupo.firstElementChild);
        this.construir();
      }

      clonar(elemento) {
        const copia = elemento.cloneNode(true);
        copia.removeAttribute('data-original');
        copia.setAttribute('data-copia', '');
        copia.setAttribute('aria-hidden', 'true');
        copia.setAttribute('inert', '');
        [copia, ...copia.querySelectorAll('*')].forEach((nodo) => {
          nodo.removeAttribute('id');
          nodo.removeAttribute('data-shopify-editor-block');
        });
        return copia;
      }

      construir() {
        if (this.animacion) this.animacion.cancel();
        this.querySelectorAll('[data-copia]').forEach((nodo) => nodo.remove());
        this.dataset.animada = 'false';
        if (this.reducido.matches || this.seleccionado || !this.ventana.clientWidth) return;
        const originales = Array.from(this.grupo.children);
        let ancho = this.grupo.getBoundingClientRect().width;
        if (!ancho) return;
        const repeticiones = Math.ceil(this.ventana.clientWidth / ancho);
        for (let vuelta = 1; vuelta < repeticiones; vuelta++) {
          originales.forEach((tarjeta) => this.grupo.appendChild(this.clonar(tarjeta)));
        }
        ancho = this.grupo.getBoundingClientRect().width;
        this.pista.appendChild(this.clonar(this.grupo));
        this.ventana.scrollLeft = 0;
        this.dataset.animada = 'true';
        const velocidad = Math.max(10, Number(this.dataset.velocidad) || 35);
        this.animacion = this.pista.animate([
          { transform: 'translateX(0)' },
          { transform: `translateX(-${ancho}px)` }
        ], { duration: ancho / velocidad * 1000, iterations: Infinity, easing: 'linear' });
        this.estado();
      }

      estado() {
        if (!this.animacion) return;
        if (this.encima || this.enfocado || this.presionado || document.hidden) this.animacion.pause();
        else this.animacion.play();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.marco);
        if (this.animacion) this.animacion.cancel();
        if (this.observador) this.observador.disconnect();
        if (this.control) this.control.abort();
        this.querySelectorAll('[data-copia]').forEach((nodo) => nodo.remove());
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
